import React from 'react'
import { Form, Row, Col, Spinner } from 'react-bootstrap'
import { StyledFirebaseAuth } from 'react-firebaseui'
import firebase from 'firebase'
import constants from '../../../config/constants'
import { Formik } from 'formik'
import * as yup from 'yup'

interface LoginFormProps {
  emailLoginCallback: (email: string, password: string) => void
  uiConfig?: firebaseui.auth.Config
  isLoading: boolean
}

const msg = constants.inlineError
const schema = yup.object({
  email: yup
    .string()
    .email(msg.auth.invalidEmail)
    .required(msg.fieldRequired.replace('%s', 'Email')),
  password: yup.string().required(msg.fieldRequired.replace('%s', 'Password'))
})

const LoginForm: React.FC<LoginFormProps> = ({
  emailLoginCallback,
  uiConfig,
  isLoading
}) => {
  return (
    <Formik
      validationSchema={schema}
      onSubmit={values => {
        emailLoginCallback(values.email, values.password)
      }}
      initialValues={{
        email: '',
        password: ''
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        touched
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label htmlFor="login-email">Email</Form.Label>
            <Form.Control
              id="login-email"
              type="email"
              name="email"
              placeholder="Enter email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.email && !!errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="login-password">Password</Form.Label>
            <Form.Control
              id="login-password"
              type="password"
              name="password"
              placeholder="Enter password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.password && !!errors.password}
            />
            <Form.Control.Feedback type="invalid">
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group>
          <div className="text-center mt-4">
            <button
              className="mochi-button orange"
              type="submit"
              data-testid="login-submit-button"
              disabled={isLoading}
            >
              {isLoading && (
                <span className="mr-2">
                  <Spinner animation="border" size="sm" />
                </span>
              )}
              <b>{isLoading ? 'Signing in...' : 'Sign in'}</b>
            </button>
          </div>
          {uiConfig && <LoginFormSocialButtons uiConfig={uiConfig} />}
        </Form>
      )}
    </Formik>
  )
}

interface LoginFormSocialButtonsProps {
  uiConfig: firebaseui.auth.Config
}

const LoginFormSocialButtons: React.FC<LoginFormSocialButtonsProps> = ({
  uiConfig
}) => {
  return (
    <div data-testid="login-form-social-buttons">
      <Row lg={6} className="mx-auto pt-4">
        <Col className="mx-auto text-center">
          <span>or</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <StyledFirebaseAuth
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth()}
          />
        </Col>
      </Row>
    </div>
  )
}

export default LoginForm
